<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="presearch"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="rowItems"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left px-2">
            {{ props.item.created_at }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.desarrollo }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.subcondominio }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.n_vivienda }}
          </td>
          <td class="text-xs-left px-4">
            {{ props.item.fullname_contacto }}
          </td>
          <td class="text-xs-left px-4">
            {{ props.item.status }}
          </td>
          <td class="text-xs-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="show_preregistro(props.item.walkin_id)"
                        v-on="on" class="mr-2" small>
                  visibility
                </v-icon>
              </template>
              <span>Detalles</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-container grid-list-md>
      <v-dialog v-model="infodialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close_info_dialog">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Detalles del Pre-Registro</v-toolbar-title>
          </v-toolbar>
          <v-container grid-list-md fluid>
              <v-layout row wrap>
                <v-flex xs12 sm4 md4>
                  <v-select
                    v-model="status"
                    label="Estatus"
                    :items="tipo_status"
                    readonly
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm8 md8>
                  <v-textarea
                    v-model="observaciones"
                    label="Observaciones"
                    no-resize
                    rows="1"
                    :value="observaciones"
                    readonly
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="created_at"
                    label="Fecha"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="desarrollo"
                    label="Condominio"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Sub-Condominio"
                    v-model="subcondominio"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="n_vivienda"
                    label="Vivienda"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 class="text-md-left">
                  Datos Personales del Contacto
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="nombre_contacto"
                    label="Nombre(s)"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="apellido_paterno_contacto"
                    label="Apellido Paterno"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="apellido_materno_contacto"
                    label="Apellido Materno"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 class="text-md-left">
                  <template v-for="(visitante, index) in visitantes">
                    <v-layout row wrap v-bind:key="visitante.person_id">
                      <v-flex xs12 sm12 md12 class="text-md-left">
                        Datos Personales del Visitante No. {{ index + 1 }}
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-text-field
                          v-model="visitante.tipo"
                          label="Tipo"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <v-text-field
                          v-model="visitante.empresa"
                          label="Empresa"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          v-model="visitante.motivo"
                          label="Motivo"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          v-model="visitante.nombres"
                          label="Nombre(s)"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          v-model="visitante.apellidos"
                          label="Apellidos"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="visitante.foto_rostro!==null"
                             :src="src_image(visitante.foto_rostro)"
                             style="width: 95%"
                             alt="foto_rostro"/>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="visitante.foto_credencial_frente!==null"
                             :src="src_image(visitante.foto_credencial_frente)"
                             style="width: 95%"
                             alt="foto_credencial_frente"/>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="visitante.foto_credencial_trasera!==null"
                             :src="src_image(visitante.foto_credencial_trasera)"
                             style="width: 95%"
                             alt="foto_credencial_trasera"/>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 class="text-md-left">
                  <template v-for="(vehiculo, index) in vehiculos">
                    <v-layout row wrap v-bind:key="vehiculo.vehicle_id">
                      <v-flex xs12 sm12 md12 class="text-md-left">
                        Datos del Vehículo No. {{ index + 1 }}
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          v-model="vehiculo.placas"
                          label="Placas"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          v-model="vehiculo.color"
                          label="Color"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          v-model="vehiculo.marca"
                          label="Marca"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          v-model="vehiculo.modelo"
                          label="Modelo"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="vehiculo.foto_frontal!==null"
                             :src="src_image(vehiculo.foto_frontal)"
                             style="width: 95%"
                             alt="foto_frontal"/>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="vehiculo.foto_lateral!==null"
                             :src="src_image(vehiculo.foto_lateral)"
                             style="width: 95%"
                             alt="foto_lateral"/>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="vehiculo.foto_trasera!==null"
                             :src="src_image(vehiculo.foto_trasera)"
                             style="width: 95%"
                             alt="foto_trasera"/>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { getJWTData } from '../common/jwt.service';
import moment from '../../node_modules/moment';

export default {
  data: () => ({
    infodialog: false,
    timer: '',
    search: '',
    presearch: null,
    searchTimer: null,
    loading: true,
    totalItems: 0,
    rowItems: [],
    pagination: {},
    desarrollo: '',
    subcondominio: '',
    n_vivienda: '',
    created_at: '',
    fullname_contacto: '',
    observaciones: '',
    nombre_contacto: '',
    apellido_paterno_contacto: '',
    apellido_materno_contacto: '',
    status: '',
    visitantes: [],
    vehiculos: [],
    tipo_status: [
      { text: 'RECHAZADO', value: 'RECHAZADO' },
      { text: 'ACEPTADO', value: 'ACEPTADO' },
    ],
    headers: [
      { text: 'Fecha', value: 'created_at', sortable: true },
      { text: 'Condominio', value: 'desarrollo', sortable: true },
      { text: 'Sub-Condominio', value: 'subcondominio', sortable: true },
      { text: 'Vivienda', value: 'n_vivienda', sortable: true },
      { text: 'Nombre Contacto', value: 'fullname_contacto', sortable: true },
      { text: 'Estado', value: 'status', sortable: true },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
  }),
  computed: {
    preregistro_info() {
      return this.$store.getters['historicoPreRegistro/preregistro_info'];
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
          .then((data) => {
            this.rowItems = data.items;
            this.totalItems = data.total;
          });
      },
      deep: true,
    },
    search() {
      this.getDataFromApi()
        .then((data) => {
          this.rowItems = data.items;
          this.totalItems = data.total;
        });
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
    preregistro_info(val) {
      if (typeof val.walkin_id !== 'undefined') {
        this.init_edit_data(val);
      }
    },
  },
  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        const formdata = {
          page,
          rowsPerPage,
          search: this.search,
          sortBy,
          descending,
        };
        this.$store.dispatch('historicoPreRegistro/fetchPreregistros', formdata)
          .then(() => {
            this.loading = false;
            const items = this.$store.getters['historicoPreRegistro/preregistro_list'];
            const total = this.$store.getters['historicoPreRegistro/preregistro_total'];

            this.$store.commit('historicoPreRegistro/fetchedPreregistros');
            resolve({
              items,
              total,
            });
          });
      });
    },
    is_admin() {
      if (getJWTData().user_claims.role === 'admin') {
        return true;
      }
      return false;
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    src_image(image) {
      const base = 'data:image/jpeg;base64, ';
      if (typeof image !== 'undefined') {
        return base.concat(image);
      }
      return null;
    },
    init_edit_data(data) {
      this.status = data.status;
      this.observaciones = data.observaciones;
      this.created_at = data.created_at;
      this.desarrollo = data.desarrollo;
      this.subcondominio = data.subcondominio;
      this.n_vivienda = data.n_vivienda;
      this.nombre_contacto = data.nombre_contacto;
      this.apellido_paterno_contacto = data.apellido_paterno_contacto;
      this.apellido_materno_contacto = data.apellido_materno_contacto;
      this.visitantes = [...data.persons];
      this.vehiculos = [...data.vehicles];
    },
    show_preregistro(id) {
      this.$store.dispatch('historicoPreRegistro/fetchPreregistroInfo', id);
      this.infodialog = true;
    },
    close_info_dialog() {
      this.infodialog = false;
      this.status = '';
      this.observaciones = '';
      this.created_at = '';
      this.desarrollo = '';
      this.subcondominio = '';
      this.n_vivienda = '';
      this.nombre_contacto = '';
      this.apellido_paterno_contacto = '';
      this.apellido_materno_contacto = '';
      this.visitantes = [];
      this.vehiculos = [];
      this.$store.commit('historicoPreRegistro/clearPreregistroInfo');
      this.$store.commit('historicoPreRegistro/clearAlertDialog');
      this.$store.commit('historicoPreRegistro/resetPreregistroProcessing');
    },
    fetch_preregistro_list() {
      if (!this.$store.getters['historicoPreRegistro/loading_preregistros']) {
        this.$store.dispatch('historicoPreRegistro/clearPreregistrosAction');
        this.$store.dispatch('historicoPreRegistro/fetchPreregistros');
      }
    },
  },
  beforeDestroy() {
    this.cancelSearchTimer();
  },
  created() {
    /*
    if (!(this.$store.getters['historicoPreRegistro/preregistro_list'].length > 0)) {
      this.fetch_preregistro_list();
    } else {
      this.$store.commit('historicoPreRegistro/fetchedPreregistros');
    }
    */
  },
};
</script>
